import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { interval } from 'rxjs';

@Component({
  selector: 'app-license-meis',
  templateUrl: './license-meis.component.html',
  styleUrls: ['./license-meis.component.scss']
})
export class LicenseMEISComponent implements OnInit {

  isShownError: boolean = true;
  isShownSuccess: boolean = true;
  Status: boolean = false;
  ErrorMsg: string;
  SuccessMsg: string;
  isShownSaveBtn: boolean = false;
  isShownUpdateBtn: boolean = true;
  isShownActive: Boolean = true;
  isShownadBtn: Boolean = false;
  isShownupdBtn: Boolean = true;
  LicenseNumber: string;
  LicenseDate: string;
  ValidFrom: string;
  ValidTo: string;
  LicCurrency: string;
  LicValue: string;
  AvlValue: string;
  Roq: string;
  crntstatus :string;
  Description: string;
  public searchText: string;
  licenseExport = [] as any;
  Editedlicense = [] as any;
  EditedlicenseId: string;
  EditedlicenseType :string;
  slicId: string;
  sOnboardingId: string;

  @ViewChild('file')
  myInputVariable: ElementRef;

  displayedColumns1: string[] = ['sno', 'number', 'licenseDate1', 'validFrom1', 'validTo1', 'roq', 'value', 'status'];
  dataSource1: MatTableDataSource<any[]>;
  @ViewChild('paginator1', { static: true }) paginator1: MatPaginator;
  @ViewChild('sort1', { static: true }) sort1: MatSort;
  @ViewChild('TABLE1') table2: ElementRef;

  constructor(private http: HttpClient) { }
  ngOnInit(): void {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
    }
    interval(3000).subscribe(x => {
     
      this.BindMEISGrid();
    this.BindMEISExport();
      });
    
  }

  Submitlic() {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
      return false;
    }
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.Status = false;
    var vlicnum = this.LicenseNumber;
    var vlicdate = this.LicenseDate;
    var vvalidfrom = this.ValidFrom;
    var vvalidto = this.ValidTo;
    var vlicvalue = this.LicValue;
    var vavlvalue = this.AvlValue;
    var vroq = this.Roq;
    var vdescription = this.Description;
    var vcrntstatus = this.crntstatus;
    debugger;

    if (vlicnum == undefined || vlicnum == "" || vlicnum == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter MIES License Number.";
      return false;
    }
    if (vlicdate == undefined || vlicdate == "" || vlicdate == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter License Date.";
      return false;
    }
    if (vvalidfrom == undefined || vvalidfrom == "" || vvalidfrom == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter ValidFrom Date.";
      return false;
    }
    if (vvalidto == undefined || vvalidto == "" || vvalidto == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter ValidTo Date.";
      return false;
    }
    if (vlicvalue == undefined || vlicvalue == "" || vlicvalue == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter License Value.";
      return false;
    }
    if (vavlvalue == undefined || vavlvalue == "" ) {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Available Value.";
      return false;
    }
    if (vroq == undefined || vroq == "" || vroq == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter ROQ.";
      return false;
    }
    if (vdescription == undefined || vdescription == "" || vdescription == "0") {
      this.Description = "";
    }

    if(vlicvalue == vavlvalue)
    {
      this.crntstatus="Available";
    }
    else if(vavlvalue == "0")
    {
      this.crntstatus="Closed";
    }
    else
    {
      this.crntstatus="Available";
    }
   
    let params = new HttpParams();
    params = params.append('dlicnum', this.LicenseNumber);
    params = params.append('dlicdate', this.LicenseDate);
    params = params.append('dvalidfrom', this.ValidFrom);
    params = params.append('dvalidto', this.ValidTo);
    params = params.append('dlicvalue', this.LicValue);
    params = params.append('davlvalue', this.AvlValue);
    params = params.append('droq', this.Roq);
    params = params.append('ddescription', this.Description);
    params = params.append('dcrntstatus', this.crntstatus);
    params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'LicenseMEIS/InsertLicense', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var meiscode = data;
        this.LicenseNumber = "";
        this.LicenseDate = "";
        this.ValidFrom = "";
        this.ValidTo = "";
        this.LicValue = "";
        this.AvlValue = "";
        this.Roq = "";
        this.Description = "";
        this.crntstatus="";
        this.isShownSuccess = false;
        this.SuccessMsg = "License-MEIS Added."
        this.BindMEISGrid();
        this.BindMEISExport();
        return false;
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Insert Failed, Please Try Again.";
          return false;
        }
        else if (vErrorMsg1 == "Exist") {
          this.isShownError = false;
          this.ErrorMsg = "License Number, Already Exists.";
          return false;
        }
        else {
        }
      });
  }

  Editlicmeis(item: any) {
    this.isShownSaveBtn = true;
    this.isShownUpdateBtn = false;
    this.isShownActive = false;
    this.Status = false;
    this.isShownSuccess = true;
    this.isShownError = true;
    this.SuccessMsg = "";
    this.ErrorMsg = "";
    this.Editedlicense = item;
    debugger;
    var vtype = this.Editedlicense.type;
    var vnumber = this.Editedlicense.number;
    var vlicenseDate = this.Editedlicense.licenseDate;
    var vvalidFrom = this.Editedlicense.validFrom;
    var vvalidTo = this.Editedlicense.validTo;
    var vvalue = this.Editedlicense.value;
    var vdescription = this.Editedlicense.description;
    var vroq = this.Editedlicense.roq;
    var vbalvalue = this.Editedlicense.availablevalue;
    var vcrntstatus = this.Editedlicense.crntstatus;
    var vstatus = this.Editedlicense.status;
    var vlicenseinfoid = this.Editedlicense.licenseinfoid;
    debugger;
    this.EditedlicenseId = vlicenseinfoid;
    this.EditedlicenseType = vtype;
    this.LicenseNumber = vnumber;
    this.LicenseDate = new Date(new Date(vlicenseDate).setDate(new Date(vlicenseDate).getDate() + 1)).toISOString().split('T')[0];
    this.ValidFrom = new Date(new Date(vvalidFrom).setDate(new Date(vvalidFrom).getDate() + 1)).toISOString().split('T')[0];
    this.ValidTo = new Date(new Date(vvalidTo).setDate(new Date(vvalidTo).getDate() + 1)).toISOString().split('T')[0];
    this.LicValue = vvalue;
    this.AvlValue = vbalvalue;
    this.Roq=vroq;
    this.crntstatus=vcrntstatus;
    this.Description = vdescription;
    if (vstatus == "Active") {
      this.Status = false;
    }
    else {
      this.Status = true;
    }
  }

  Updatelic() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    var vlicnum = this.LicenseNumber;
    var vlicdate = this.LicenseDate;
    var vvalidfrom = this.ValidFrom;
    var vvalidto = this.ValidTo;
    var vlicvalue = this.LicValue;
    var vavlvalue = this.AvlValue;
    var vroq = this.Roq;
    var vdescription = this.Description;
    debugger;

    if (vlicnum == undefined || vlicnum == "" || vlicnum == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter MIES License Number.";
      return false;
    }
    if (vlicdate == undefined || vlicdate == "" || vlicdate == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter License Date.";
      return false;
    }
    if (vvalidfrom == undefined || vvalidfrom == "" || vvalidfrom == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter ValidFrom Date.";
      return false;
    }
    if (vvalidto == undefined || vvalidto == "" || vvalidto == "") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter ValidTo Date.";
      return false;
    }
    if (vlicvalue == undefined || vlicvalue == "" || vlicvalue == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter License Value.";
      return false;
    }
    // if (vavlvalue == undefined || vavlvalue == "" || vavlvalue == "0") {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Enter Available Number.";
    //   return false;
    // }
    if (vroq == undefined || vroq == "" || vroq == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter ROQ.";
      return false;
    }
    if (vdescription == undefined || vdescription == "" || vdescription == "0") {
      this.Description = "";
    }

    var vStatus = "Active";
    if (this.Status == true)
      vStatus = "InActive";
    else
      vStatus = "Active";

    let params = new HttpParams();
    params = params.append('dlicnum', this.LicenseNumber);
    params = params.append('dlicdate', this.LicenseDate);
    params = params.append('dvalidfrom', this.ValidFrom);
    params = params.append('dvalidto', this.ValidTo);
    params = params.append('dlicvalue', this.LicValue);
    params = params.append('davlvalue', this.AvlValue);
    params = params.append('droq', this.Roq);
    params = params.append('ddescription', this.Description);
    params = params.append('dstatus', vStatus);
    params = params.append('dlicId', this.EditedlicenseId);
    params = params.append('dType', this.EditedlicenseType);
    var value = this.http.get(environment.apiUrl + 'LicenseMEIS/UpdateLicense', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var meiscode = data;
        this.LicenseNumber = "";
        this.LicenseDate = "";
        this.ValidFrom = "";
        this.ValidTo = "";
        this.LicValue = "";
        this.AvlValue = "";
        this.Roq = "";
        this.Description = "";
        this.isShownSuccess = false;
        this.SuccessMsg = "License-MEIS Updated."
        this.BindMEISGrid();
        this.BindMEISExport();
        return false;
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Update Failed, Please Try Again.";
          return false;
        }
        else if (vErrorMsg1 == "Success")
        { 
          var meiscode = data;
          this.LicenseNumber = "";
          this.LicenseDate = "";
          this.ValidFrom = "";
          this.ValidTo = "";
          this.LicValue = "";
          this.AvlValue = "";
          this.Roq = "";
          this.Description = "";
          this.isShownSuccess = false;
          this.SuccessMsg = "License-MEIS Updated."
          this.BindMEISGrid();
          this.BindMEISExport();
          return false;
        }
        else{

        }
      });

  }

  Clearlic() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.isShownActive = true;
    this.isShownSaveBtn = false;
    this.isShownUpdateBtn = true;
    this.Status = false;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.LicenseNumber = "";
    this.LicenseDate = "";
    this.ValidFrom = "";
    this.ValidTo = "";
    this.LicValue = "";
    this.AvlValue = "";
    this.Roq = "";
    this.Description = "";
  }

  BindMEISGrid() {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    var vtype = "MEIS";
    let params = new HttpParams();
    params = params.append('dtype',vtype);
    params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'LicenseMEIS/GetLicenseForGrid',{params : params}).toPromise().then(
      (data: any) => {
        debugger;
        this.dataSource1 = new MatTableDataSource(data);
        this.dataSource1.data = data;
        this.dataSource1.paginator = this.paginator1;
        this.dataSource1.sort = this.sort1;
      });
  }

  applyFilter(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource1.filter = filterValue;
  }

  BindMEISExport() {
     this.sOnboardingId = localStorage.getItem('OnboardingId');
    let params = new HttpParams();
    params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'LicenseMEIS/GetLicenseForExport',{params : params}).toPromise().then(
      (data: any) => {
        debugger;
        this.licenseExport = data;
      });
  }

  exportexcel(): void {
    debugger;
    /* table id is passed over here */
    const workSheet = XLSX.utils.json_to_sheet(this.licenseExport);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, workSheet, 'License-MEIS');

    /* save to file */
    XLSX.writeFile(wb, "License-MEIS.xlsx");

  }

}
